import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  /** Nome do bloco, mostrado no aviso. */
  nome?: string;
}
interface Estado {
  erro: Error | null;
}

/**
 * Isola falhas de renderização: se um bloco quebrar, aparece um aviso no lugar dele e o resto da
 * tela continua funcionando, em vez de a página inteira ficar em branco.
 */
export class LimiteErro extends Component<Props, Estado> {
  state: Estado = { erro: null };

  static getDerivedStateFromError(erro: Error): Estado {
    return { erro };
  }

  componentDidCatch(erro: Error, info: ErrorInfo) {
    console.error(`Erro no bloco ${this.props.nome ?? ''}:`, erro, info.componentStack);
  }

  render() {
    if (this.state.erro) {
      return (
        <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-800">
          <b>Este bloco não pôde ser exibido{this.props.nome ? ` (${this.props.nome})` : ''}.</b> O
          resto da tela continua funcionando. Detalhe técnico: {this.state.erro.message}
          <div className="mt-2">
            <button
              type="button"
              className="rounded-lg border border-red-300 px-3 py-1 text-xs hover:bg-red-100"
              onClick={() => this.setState({ erro: null })}
            >
              Tentar de novo
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
